import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import emptyStateMenu from './empty-state-menu.hbs'
import noPermission from 'scoreboard/components/no-permission.hbs'
import EmptyState from 'scoreboard/components/empty-state'
import notFound from 'scoreboard/components/not-found.hbs'
import notImplemented from 'scoreboard/components/not-implemented.hbs'
import NoObject from 'scoreboard/components/no-object'

var EmptyStateView = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view admin-test-empty-states',

	initialize: function(options) {
		this.options = options
	},

	render: function () {
		switch (this.options.view) {
			case 'all':
				this.$el.empty().append(emptyStateMenu())
				break
			case 'locked':
				appDisplay.display(new EmptyState({ body: noPermission() }))
				break
			case 'not-found':
				appDisplay.display(new EmptyState({ body: notFound() }))
				break
			case 'not-implemented':
				appDisplay.display(new EmptyState({ body: notImplemented({
					sectionIcon: 'metric'
				})}))
				break
			default:
				appDisplay.display(new NoObject({ section: this.options.view }))
		}
		return this
	}
})

export default EmptyStateView
